<template>
  <v-container fluid class="yellow-shade pa-5" style="height: 100%">
    <v-layout>
      <v-flex>
        <h3 class="d-inline-block">DSEC Event Tracker</h3>
        <v-btn
          v-if="amazeUserCan('create', 'dsec_calendar')"
          color="primary"
          @click="overlay('event-form', {})"
          class="ml-4 addEventButton"
          ><v-icon class="mr-2" small>fa fa-plus</v-icon>Add Event</v-btn
        >
      </v-flex>

      <v-flex class="text-xs-right">
        <v-btn
          @click="adminExport()"
          flat
          v-if="amazeUserCan('admin_view', 'dsec_calendar')"
          ><v-icon class="mr-2" small>fa fa-th</v-icon> Admin Export</v-btn
        >
        <v-btn
          href="https://amaze-assets.s3.us-west-1.amazonaws.com/public/event_tracker/Location-Template-DSEC2.0.xlsx"
          download
          flat
          ><v-icon class="mr-2" small>fa fa-file-excel</v-icon> Location Data
          Template</v-btn
        >
        <div
          v-if="userHasPartners"
          v-for="partner in userPartners"
          v-bind:key="partner.id"
        >
          <v-btn
            class="xs12"
            v-if="partner.program_reporting_url"
            :href="partner.program_reporting_url"
            target="blank"
            rel="noopener"
            pa0
            xs12
            flat
            ><v-icon class="mr-2" small>fa fa-server</v-icon>
            {{ partner.name }} Program Data Reporting</v-btn
          >
          <span v-if="partner.program_data_url"> | </span>
          <v-btn
            class="xs12"
            v-if="partner.program_data_url"
            :href="partner.program_data_url"
            target="blank"
            rel="noopener"
            xs12
            flat
          >
            See My Data</v-btn
          >
        </div>
      </v-flex>
    </v-layout>

    <v-tabs
      justified
      v-model="tab"
      slider-color="primary"
      class="dashboardTabs mt-3"
      @change="tabChanged"
      show-arrows
    >
      <v-tab
        key="table"
        class="px-3"
        v-if="amazeUserCan('admin_view', 'dsec_calendar')"
      >
        Table <span class="ml-1 hidden-sm-and-down">View</span>
      </v-tab>
      <v-tab key="month" class="px-3" @click="rerender" v-else>
        Calendar <span class="ml-1 hidden-sm-and-down">View</span>
      </v-tab>

      <v-tab
        key="month"
        class="px-3"
        @click="rerender"
        v-if="amazeUserCan('admin_view', 'dsec_calendar')"
      >
        Calendar <span class="ml-1 hidden-sm-and-down">View</span>
      </v-tab>
      <v-tab key="table" class="px-3" v-else>
        Table <span class="ml-1 hidden-sm-and-down">View</span>
      </v-tab>

      <v-tab
        key="partners"
        v-if="amazeUserCan('admin_view', 'dsec_calendar')"
        class="px-3"
      >
        Partners/Hubs <span class="ml-1 hidden-sm-and-down">CMS</span>
      </v-tab>

      <v-tab
        key="programs"
        v-if="amazeUserCan('admin_view', 'dsec_calendar')"
        class="px-3"
      >
        Programs <span class="ml-1 hidden-sm-and-down">CMS</span>
      </v-tab>

      <v-tab-item
        key="table"
        v-if="amazeUserCan('admin_view', 'dsec_calendar')"
      >
        <table-view
          @view-event="overlay"
          @edit-event="overlay"
          @admin-event="overlay"
        />
      </v-tab-item>

      <v-tab-item key="month" lazy v-else>
        <month-view @view-event="overlay" />
      </v-tab-item>

      <v-tab-item
        key="month"
        lazy
        v-if="amazeUserCan('admin_view', 'dsec_calendar')"
      >
        <month-view @view-event="overlay" />
      </v-tab-item>

      <v-tab-item key="table" v-else>
        <table-view
          @view-event="overlay"
          @edit-event="overlay"
          @admin-event="overlay"
        />
      </v-tab-item>

      <v-tab-item
        key="partners"
        v-if="amazeUserCan('admin_view', 'dsec_calendar')"
      >
        <partner-view @edit-partner="overlay" />
      </v-tab-item>

      <v-tab-item
        key="program"
        v-if="amazeUserCan('admin_view', 'dsec_calendar')"
      >
        <program-view @edit-program="overlay" />
      </v-tab-item>
    </v-tabs>

    <vue-slideout-panel
      v-model="dialog"
      :widths="widths"
      @close="dialog = false"
      :styles="slideStyles"
      :closeHtml="slideClose"
    >
      <component
        v-bind:is="slideOutComponent"
        :item="item"
        @close="dialog = false"
        @edit-event="overlay"
        @admin-event="overlay"
        @view-event="overlay"
      ></component>
    </vue-slideout-panel>
  </v-container>
</template>

<style lang="scss" scoped>
.addEventButton {
  margin-top: -0.5rem;
}

@media (max-width: 715px) {
  .addEventButton {
    margin-top: 15px;
    margin-left: 0px !important;
    display: block;
  }
}

@media (max-width: 579px) {
  .layout {
    display: block !important;
    .text-xs-right {
      text-align: left !important;
      margin-left: -16px;
    }
    .sm12 {
      width: 100% !important;
      min-width: 100% !important;
    }
  }
}
</style>

<script>
import VueSlideoutPanel from "vue-slideout-panel";
import FileSaver from "file-saver";

import MonthView from "@/components/Widgets/DSEC/MonthView";
import TableView from "@/components/Widgets/DSEC/TableView";
import PartnerView from "@/components/Widgets/DSEC/PartnerView";
import ProgramView from "@/components/Widgets/DSEC/ProgramView";
import EventView from "@/components/Widgets/DSEC/EventView";

import EventForm from "@/components/Widgets/DSEC/EventForm";
import AdminForm from "@/components/Widgets/DSEC/AdminForm";
import PartnerForm from "@/components/Widgets/DSEC/PartnerForm";
import ProgramForm from "@/components/Widgets/DSEC/ProgramForm";

import { EventBus } from "@/components/Events/event-bus.js";

import permissionsMixin from "@/mixins/permissionsMixin.js";

export default {
  components: {
    "vue-slideout-panel": VueSlideoutPanel,
    "month-view": MonthView,
    "table-view": TableView,
    "partner-view": PartnerView,
    "program-view": ProgramView,
    "event-view": EventView,
    "event-form": EventForm,
    "admin-form": AdminForm,
    "partner-form": PartnerForm,
    "program-form": ProgramForm
  },
  mixins: [permissionsMixin],
  data() {
    return {
      dialog: false,
      slideStyles: [
        {},
        {},
        {},
        { color: "#555", textDecoration: "none", top: "8px", right: "1rem" }
      ],
      slideClose: "<i class='fas fa-times'></i>",
      tab: 0,
      slideOutComponent: "event-view",
      item: {}
    };
  },
  computed: {
    userHasPartners() {
      let user = this.$auth.user();
      return user.dsec_partners && user.dsec_partners.length > 0;
    },
    userPartners() {
      let user = this.$auth.user();
      return user.dsec_partners && user.dsec_partners.length > 0
        ? user.dsec_partners.sort((a, b) => a.name.localeCompare(b.name))
        : [];
    },
    widths() {
      if (this.$vuetify.breakpoint.xsOnly) return ["100%"];
      else if (this.$vuetify.breakpoint.mdAndDown) return ["75%"];
      else return ["35%"];
    }
  },
  watch: {
    dialog: function (val) {
      var html = document.getElementsByTagName("html")[0];
      if (val) {
        html.style.overflow = "hidden";
      } else {
        html.style.overflow = "auto";
      }
    }
  },
  methods: {
    overlay(component, item) {
      this.item = item;
      this.slideOutComponent = component;
      this.dialog = true;
    },

    async adminExport() {
      let file = await this.$http.post(
        "dsec/export",
        {},
        { responseType: "blob" }
      );
      FileSaver.saveAs(file.data, "DSECExport.xlsx");
    },
    rerender() {
      EventBus.$emit("renderCalendar");
    }
  },
  mounted() {}
};
</script>
